import Reveal from '@/components/base/Reveal';

interface SectionHeadingProps {
  label: string;
  title: string;
  description?: string;
  align?: 'left' | 'center';
}

export default function SectionHeading({ label, title, description, align = 'center' }: SectionHeadingProps) {
  const isCenter = align === 'center';

  return (
    <div className={isCenter ? 'text-center max-w-3xl mx-auto' : 'max-w-3xl'}>
      <Reveal>
        <span className="inline-flex items-center gap-2 text-xs font-semibold tracking-[0.18em] uppercase text-primary-400">
          <span className="w-6 h-px bg-primary-400"></span>
          {label}
        </span>
      </Reveal>
      <Reveal delay={100}>
        <h2 className="mt-4 font-heading font-bold text-2xl md:text-4xl leading-tight tracking-tight text-foreground-950">
          {title}
        </h2>
      </Reveal>
      {description && (
        <Reveal delay={180}>
          <p className={`mt-5 text-sm md:text-base text-foreground-700 leading-relaxed ${isCenter ? 'mx-auto' : ''}`}>
            {description}
          </p>
        </Reveal>
      )}
    </div>
  );
}